import styled, { css } from 'styled-components';

export const GalleryDrawerGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  padding: 0 15px 65px;
`;

export const GalleryDrawerItem = styled.div`
  position: relative;
`;

export const GalleryDrawerImage = styled.img`
  border-radius: 7px;
`;

export const GalleryDrawerCheckbox = styled.span<{ $isSelected: boolean }>`
  width: 20px;
  height: 20px;
  border-radius: 5px;
  position: absolute;
  top: 5px;
  right: 5px;

  ${({ $isSelected }) =>
    !$isSelected &&
    css`
      border: 1px solid var(--light-mode-border-primary, #eaebf2);
      background: rgba(255, 255, 255, 0.5);
    `}
`;

export const GalleryDrawerApply = styled.div`
  position: fixed;
  bottom: 15px;
  width: 100%;
  padding: 0 15px;
`;
